import "react-datepicker/dist/react-datepicker.css";

import { ko } from "date-fns/locale";
import DatePicker, { registerLocale } from "react-datepicker";
import { twJoin, twMerge } from "tailwind-merge";

export interface DateRangePickerProps {
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (value: Date | null) => void;
    setEndDate: (value: Date | null) => void;
    type?: number;
    timePicker?: boolean;
    timeIntervals?: number;
}

export default function DateRangePicker({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    type = 1,
    timePicker,
    timeIntervals = 30,
}: DateRangePickerProps) {
    registerLocale("ko", ko);

    const ulBaseStyle =
        "flex relative after:absolute after:content-['~'] after:w-[10px] after:h-[20px] after:text-[14px] after:font-[500] after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2";
    const ulStyle = twMerge(
        ulBaseStyle,
        type === 1 ? "gap-[10px] border border-[#ddd] bg-white rounded-[5px]" : "flex-col gap-[20px]",
    );
    const liBaseStyle = "flex-1 relative pl-[65px]";
    const liStyle = twMerge(liBaseStyle, type === 1 ? "" : "border border-[#ddd] bg-white rounded-[5px]");
    const inputBaseStyle =
        "w-full h-[34px] rounded-[5px] text-[14px] pr-[36px] bg-icCalendar bg-no-repeat bg-[right_12px_center]";
    const inputStyle = twJoin(inputBaseStyle, type === 1 ? "" : "pr-[60px] text-center");

    return (
        <ul className={ulStyle}>
            <li className={liStyle}>
                <p className="absolute left-[12px] top-1/2 -translate-y-1/2 font-[500]">시작일</p>
                <div className="flex-1 [&>.react-datepicker-wrapper]:w-full">
                    <DatePicker
                        selected={startDate}
                        onChange={setStartDate}
                        selectsStart
                        locale="ko"
                        className={inputStyle}
                        dateFormat={timePicker ? "yyyy.MM.dd HH:mm" : "yyyy.MM.dd"}
                        showTimeSelect={timePicker}
                        timeIntervals={timeIntervals}
                    />
                </div>
            </li>
            <li className={liStyle}>
                <p className="absolute left-[12px] top-1/2 -translate-y-1/2 font-[500]">종료일</p>
                <div className="flex-1 [&>.react-datepicker-wrapper]:w-full">
                    <DatePicker
                        selected={endDate}
                        onChange={setEndDate}
                        selectsEnd
                        locale="ko"
                        className={inputStyle}
                        dateFormat={timePicker ? "yyyy.MM.dd HH:mm" : "yyyy.MM.dd"}
                        showTimeSelect={timePicker}
                        minDate={startDate || undefined}
                        timeIntervals={timeIntervals}
                    />
                </div>
            </li>
        </ul>
    );
}
